import React from "react"
import { Link } from "gatsby"

import Layout from "../components/Layout"
import HomePageOpportunity from "../components/HomePageOpportunity"
import findSponsorsGraphic from "../img/find-sponsors-graphic.svg"
import collectTipsGraphic from "../img/collect-tips-graphic.svg"
import createOpportunitiesGraphic from "../img/create-opportunities-graphic.svg"
import BannerButton from "../models/bannerButton"
import BannerWithButtons from "../components/BannerWithButtons"
import HomePageFeaturedBox from "../components/HomePageFeaturedBox"
import FeaturesTile from "../components/features-tile/FeaturesTile"
import { FeaturesTileContainer } from "../styles/styled-components/homeStyles"

const IndexPage = () => {
  const buttons = [
    new BannerButton(
      "Get Sponsors & Collect Tips",
      "is-link",
      "",
      {
        signupPayload: {
          message:
            "Collect tips from your fans and get sponsored by companies and brands!",
        },
      },
      "/app/signup?type=creator"
    ),
    new BannerButton(
      "Become a Sponsor",
      "is-info",
      "has-text-black",
      {
        signupPayload: {
          message:
            "Looking for sponsorship opportunities? Browse our free list of podcasts, social media influencers, events, and more.",
        },
      },
      "/app/signup?type=sponsor"
    ),
  ]
  return (
    <Layout>
      <BannerWithButtons
        image="./img/banner-index.jpg"
        title="Find Sponsorship Opportunities"
        subtitle="Connecting creators with the companies looking to sponsor them"
        buttons={buttons}
      />

      <section className="section section--gradient">
        <div className="container">
          <FeaturesTileContainer className="tile is-ancestor">
            <div className="tile is-parent is-vertical is-4 is-hidden-touch">
              <FeaturesTile
                imgSrc={findSponsorsGraphic}
                imgTitle="Find Sponsors"
                imgAlt="Woman with credit card and cash"
                tileTitle="Find Sponsors"
              />
            </div>
            <div className="tile is-parent is-vertical is-4 is-hidden-desktop box">
              <FeaturesTile
                imgSrc={findSponsorsGraphic}
                imgTitle="Find Sponsors"
                imgAlt="Woman with credit card and cash"
                tileTitle="Find Sponsors"
              />
            </div>

            <div className="tile is-parent is-vertical is-4 is-hidden-touch">
              <FeaturesTile
                imgSrc={collectTipsGraphic}
                imgTitle="Collect Tips"
                imgAlt="Two people digitally exchanging cash"
                tileTitle="Collect Tips"
              />
            </div>
            <div className="tile is-parent is-vertical is-4 is-hidden-desktop box">
              <FeaturesTile
                imgSrc={collectTipsGraphic}
                imgTitle="Collect Tips"
                imgAlt="Two people digitally exchanging cash"
                tileTitle="Collect Tips"
              />
            </div>

            <div className="tile is-parent is-vertical is-4 is-hidden-touch">
              <FeaturesTile
                imgSrc={createOpportunitiesGraphic}
                imgTitle="Create Sponsorship Opportunities"
                imgAlt="Businessman pitching his idea"
                tileTitle="Create Opportunities"
              />
            </div>
            <div className="tile is-parent is-vertical is-4 is-hidden-desktop box">
              <FeaturesTile
                imgSrc={createOpportunitiesGraphic}
                imgTitle="Create Sponsorship Opportunities"
                imgAlt="Businessman pitching his idea"
                tileTitle="Create Opportunities"
              />
            </div>
          </FeaturesTileContainer>
        </div>
      </section>

      <section className="section section--gradient info-gradient">
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="content">
                <div className="columns">
                  <div className="column">
                    <h2 className="is-size-3 has-text-centered">
                      Collect tips from your fans and get sponsored by companies
                      and brands!
                    </h2>
                    <p className="has-text-centered is-size-6-mobile is-size-5-tablet is-size-5-widescreen">
                      <strong>Looking For Sponsor</strong> is dedicated to
                      empowering content creators and sponsorship seekers of all
                      kinds. Whether you're a YouTuber ready to turn your hobby
                      into a side-hustle or a nonprofit looking for companies
                      that sponsor events, we've got something to help you reach
                      your goals.
                    </p>
                    <div className="has-text-centered">
                      <Link
                        to="/support/faq"
                        className="button is-link is-large is-rounded"
                      >
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--gradient">
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="content">
                <h2 className="is-size-3 has-text-centered">
                  Featured Sponsorship Opportunities
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="content">
                <div className="columns">
                  <div className="column">
                    <HomePageFeaturedBox
                      title="Where Eagles Fly"
                      description="Sponsor a new streaming show raising awareness for endangered wilderness, wildlands, and wildlife habitats."
                      page="2020-08-19-where-eagles-fly"
                      image="./img/logo_where_eagles_fly.png"
                    />
                  </div>
                  <div className="column">
                    <HomePageFeaturedBox
                      title="Absurd Hypotheticals"
                      description="Sponsor a podcast that answers silly hypothetical
                        questions with a dash of science."
                      page="2020-06-26-podcast-sponsorship-absurd-hypotheticals"
                      image="./img/logo_absurd_hypotheticals.jpg"
                    />
                  </div>
                  <div className="column">
                    <HomePageFeaturedBox
                      title="MeCHo Radio"
                      description="Sponsor one of the many podcasts created by the MeCHo Radio podcast production house."
                      page="2020-08-07-podcast-sponsorship-mecho-radio"
                      image="./img/logo_mecho_radio.png"
                    />
                  </div>
                </div>
                <div className="columns">
                  <div className="column">
                    <HomePageFeaturedBox
                      title="Film on the Rocks"
                      description="Sponsor a podcast that discusses movies and the drinking games that should accompany them."
                      page="2020-08-26-podcast-sponsorship-film-on-the-rocks"
                      image="./img/logo_film_on_the_rocks.png"
                    />
                  </div>
                  <div className="column">
                    <HomePageFeaturedBox
                      title="Clout Chasers"
                      description="Sponsor a rapidly growing, journalism-style YouTube
                        channel with videos that are viewed by thousands."
                      page="2020-06-19-youtube-sponsorship-clout-chasers"
                    />
                  </div>
                  <div className="column">
                    <HomePageFeaturedBox
                      title="SpazzoutTTV"
                      description="Sponsor a video game streamer with an audience of over 1,800 on Twitch."
                      page="2020-07-24-streamer-sponsorship-spazzoutttv"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--gradient">
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="content">
                <h2 className="is-size-2 has-text-centered">
                  Who Uses Looking For Sponsor?
                </h2>
                <p className="has-text-centered is-size-6-mobile is-size-5-tablet is-size-5-widescreen">
                  If you're looking for a sponsorship or looking to collect tips from your passionate fans, then <strong>Looking For Sponsor</strong> is for you. 
                  All types of content creators and organizations use our platform, including:
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="columns">
            <div className="column">
              <HomePageOpportunity
                image="./img/streamers-photo.jpg"
                title="Streamers"
                message="Do you host a stream on sites like Twitch and YouTube? Get companies to sponsor your content and start collecting sponsorship money today."
              />
            </div>
            <div className="column">
              <HomePageOpportunity
                image="./img/youtubers-photo.jpg"
                title="YouTubers"
                message="Do you create videos on YouTube? Get companies to sponsor your content and start collecting sponsorship money today."
              />
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <HomePageOpportunity
                image="./img/podcasts-photo.jpg"
                title="Podcasts"
                message="Do you host a podcast? Get companies to sponsor your content and start collecting sponsorship money today."
              />
            </div>
            <div className="column">
              <HomePageOpportunity
                image="./img/influencers-photo.jpg"
                title="Social Media Influencers"
                message="Have a big following on platforms like Instagram and Twitter? Get companies to sponsor your posts and start collecting sponsorship money today."
              />
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <HomePageOpportunity
                image="./img/esports-photo.jpg"
                title="Esports Competitors and Teams"
                message="Are you an esports competitor or part of an esports team? Get companies to sponsor you and start collecting sponsorship money today."
              />
            </div>
            <div className="column">
              <HomePageOpportunity
                image="./img/coders-photo.jpg"
                title="Code Library Creators and Maintainers"
                message="Do you create or maintain open-source code libraries? Get companies to sponsor your projects and start collecting sponsorship money today."
              />
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <HomePageOpportunity
                image="./img/events-photo.jpg"
                title="Event Organizers"
                message="Hosting an event and need sponsors? Create a post on our platform and start collecting sponsorship money today."
              />
            </div>
            <div className="column">
              <HomePageOpportunity
                image="./img/school-teams-photo.jpg"
                title="School Clubs and Teams"
                message="Need sponsors for your school club or team? Create a post on our platform and start collecting sponsorship money today."
              />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="content">
                <h2 className="is-size-2 has-text-centered">
                  ...and many more!
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
